export default "__VITE_ASSET__Zb14Y05f__"